export function convertStylesToCSS(styles) {
    return Object.entries(styles)
        .map(([key, value]) => {
        const cssKey = key.replace(/([A-Z])/g, '-$1').toLowerCase();
        return `${cssKey}: ${value};`;
    })
        .join(' ');
}
